module.exports = __webpack_public_path__ + "static/img/s13.6562b1d4.png";